import React, {useEffect, useRef} from "react";
import "./ModernGrid.css";
import {gsap} from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import $ from "jquery";
import {useCursor} from "../../Cursor/MagicCursorProvider";
import {Link, useNavigate} from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

const ModernGrid = ({projects}) => {
  const gridRef = useRef(null);
  const {setCursorStyle, setCursorText} = useCursor();
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof window !== "undefined") {
      ScrollTrigger.matchMedia({
        "(min-width: 768px)": function () {
          const selectors = [
            ".gallery-grid.gallery-grid-layout-creative-1 .gallery-grid-item:nth-of-type(6n+2) .gallery-grid-item-inner",
            ".gallery-grid.gallery-grid-layout-creative-1 .gallery-grid-item:nth-of-type(6n+4) .gallery-grid-item-inner",
            ".gallery-grid.gallery-grid-layout-creative-2 .gallery-grid-item:nth-of-type(4n+2) .gallery-grid-item-inner",
            ".gallery-grid.gallery-grid-layout-creative-2 .gallery-grid-item:not(:last-child):nth-of-type(4n+3) .gallery-grid-item-inner",
          ];

          $(selectors.join(", ")).each(function () {
            const $this = $(this);
            const tl = gsap.timeline({
              scrollTrigger: {
                trigger: $this[0],
                start: "top bottom",
                end: "bottom top",
                scrub: 1,
              },
            });

            tl.to($this, {yPercent: -35});
          });
        },
      });
    }
  }, []);

  return (
    <div id="portfolio-grid" className="pgi-hover">
      <div className="gallery-grid gallery-grid-layout-creative-1 gallery-grid-gap-4">
        <div
          ref={gridRef}
          className="gallery-grid-items-wrap isotope-items-wrap gallery-grid gallery-grid-layout-creative-1"
        >
          {projects.map((project, index) => (
            <div key={index} className="gallery-grid-item isotope-item">
              <div className="gallery-grid-item-inner">
                <div className="portfolio-grid-item">
                  <a
                    href={`/projects/${project.slug}`}
                    className="pgi-image-wrap"
                    data-cursor="Explore<br>Project"
                    onMouseEnter={() => {
                      setCursorStyle("");
                      setCursorText("");
                      setTimeout(() => {
                        setCursorStyle("ball-view");
                        setCursorText("View<br>Project");
                      }, 10);
                    }}
                    onMouseLeave={() => {
                      setCursorStyle("");
                      setCursorText("");
                    }}
                    onClick={(e) => {
                      e.preventDefault(); // Stop default link jump
                      setCursorStyle("");
                      setCursorText("");

                      setTimeout(() => {
                        navigate(`/projects/${project.slug}`);
                      }, 100); // Allow cursor to animate before navigation
                    }}
                  >
                    <div className="pgi-image-holder">
                      <div
                        className="gallery-anim-zoomin-wrap"
                        style={{overflow: "hidden"}}
                      >
                        <div className="pgi-image-inner gallery-anim-zoomin">
                          <figure
                            className={`${
                              project.isVideo ? "pgi-video-wrap" : "pgi-image"
                            } gallery-grid-height`}
                          >
                            {project.isVideo ? (
                              <video
                                className="pgi-video"
                                loop
                                muted
                                preload="metadata"
                                poster={project.poster}
                              >
                                {project.videoSources.map((srcObj, i) => (
                                  <source
                                    key={i}
                                    src={srcObj.src}
                                    data-src={srcObj.dataSrc}
                                    type={srcObj.type}
                                  />
                                ))}
                              </video>
                            ) : (
                              <img src={project.image} alt={project.name} />
                            )}
                          </figure>
                        </div>
                      </div>
                    </div>
                  </a>

                  <div className="pgi-caption" style={{maxWidth: "100%"}}>
                    <div className="pgi-caption-inner">
                      <h2 className="pgi-title">
                        <Link to={`/projects/${project.slug}`}>
                          {project.name}
                        </Link>
                        <Link
                          to={project.websiteLink}
                          className="website-link-btn"
                          target="_blank"
                        >
                          <i className="ri-link"></i>
                        </Link>
                      </h2>
                      <div className="pgi-categories-wrap">
                        <div className="pgi-category">{project.category}</div>
                      </div>
                      <div className="tech-stacks">
                        <ul>
                          {project.tags.map((tag, idx) => (
                            <li key={idx} className={tag.color}>
                              #{tag.name}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ModernGrid;
